import { getConfig } from '../configure/utils';
export function getUsefulTooltip(target) {
    switch (target) {
        case 'table-cell':
            return getConfig('tableColumnTooltip');
        case 'button':
            return getConfig('buttonTooltip');
        case 'select-option':
            return getConfig('selectOptionTooltip');
        case 'label':
            return getConfig('labelTooltip');
        default:
    }
}
export function getTooltip(target) {
    const tooltip = getConfig('tooltip');
    if (typeof tooltip === 'function') {
        return tooltip(target);
    }
    return getUsefulTooltip(target) || tooltip;
}
export function getTooltipTheme(target) {
    const tooltipTheme = getConfig('tooltipTheme');
    if (typeof tooltipTheme === 'function') {
        return tooltipTheme(target);
    }
    if (target === 'validation') {
        const validationTooltipTheme = getConfig('validationTooltipTheme');
        if (validationTooltipTheme) {
            return validationTooltipTheme;
        }
    }
    return tooltipTheme;
}
export function getTooltipPlacement(target) {
    const tooltipPlacement = getConfig('tooltipPlacement');
    if (typeof tooltipPlacement === 'function') {
        return tooltipPlacement(target);
    }
    return tooltipPlacement;
}
